import { useMemo } from "react";
import CartValidationAlert from "../../components/cart/CartValidationAlert";
import FulfillmentSelector, { getFulfillmentOptions } from "../../components/cart/FulfillmentSelector";
import { useLocationSelection } from "../../context/LocationContext";
import { useCartValidation } from "../../hooks/useCartValidation";
import CartItemList from "./CartItemList";
import CartSummary from "./CartSummary";
import "./CartPage.css";

function CartPage({ onChooseLocation }) {
  const {
    cartItems,
    fulfillmentType,
    locations,
    selectedLocation,
    setFulfillmentType,
    updateCartItemQuantity,
    updateCartItemNote,
    removeCartItem,
  } = useLocationSelection();
  const cartLocation = useMemo(() => {
    if (selectedLocation) {
      return selectedLocation;
    }

    const cartLocationSlug = cartItems[0]?.locationSlug;
    return locations.find((location) => location.slug === cartLocationSlug) || null;
  }, [cartItems, locations, selectedLocation]);
  const fulfillmentOptions = getFulfillmentOptions(cartLocation);
  const hasFulfillmentOptions = fulfillmentOptions.length > 0;
  const { cartResult, error, loading, runValidation } = useCartValidation({
    cartItems,
    fulfillmentType,
    selectedLocation: cartLocation,
  });

  async function continueToCheckout() {
    const result = await runValidation();

    if (result?.valid) {
      window.location.href = "/checkout";
    }
  }

  if (!cartItems.length) {
    return (
      <main className="section cart-page">
        <div className="container empty-state">
          <strong>Your bag is empty.</strong>
          <span>Choose a Zayas Kitchen location and add a few favorites.</span>
          <button className="btn btn-primary" onClick={onChooseLocation} type="button">
            Start an Order
          </button>
        </div>
      </main>
    );
  }

  return (
    <main className="section cart-page">
      <div className="container cart-page-inner">
        <div className="cart-page-heading">
          <p className="eyebrow">Your Bag</p>
          <h1>Review your order</h1>
          <p className="muted-text">We validate prices and availability with the kitchen before checkout.</p>
        </div>

        <FulfillmentSelector
          fulfillmentType={fulfillmentType}
          location={cartLocation}
          onChange={setFulfillmentType}
        />

        <CartValidationAlert cartResult={cartResult} error={error} />

        <div className="cart-layout">
          <CartItemList
            cartItems={cartItems}
            onQuantityChange={updateCartItemQuantity}
            onRemove={removeCartItem}
            onUpdateNote={updateCartItemNote}
          />
          <CartSummary
            cartResult={cartResult}
            disabled={!hasFulfillmentOptions || !cartResult?.valid || loading}
            loading={loading}
            onAction={continueToCheckout}
          />
        </div>
      </div>
    </main>
  );
}

export default CartPage;
